__turbopack_context__.v({
  "addressText": "V-5r5q_addressText",
  "contactSectionContent": "V-5r5q_contactSectionContent",
  "embeddedRoot": "V-5r5q_embeddedRoot",
  "festiveHoursTitle": "V-5r5q_festiveHoursTitle",
  "festiveRoot": "V-5r5q_festiveRoot",
  "festiveShell": "V-5r5q_festiveShell",
  "hoursDayTime": "V-5r5q_hoursDayTime",
  "hoursGroup": "V-5r5q_hoursGroup",
  "hoursGroupBlock": "V-5r5q_hoursGroupBlock",
  "hoursLabel": "V-5r5q_hoursLabel",
  "hoursMuted": "V-5r5q_hoursMuted",
  "hoursNote": "V-5r5q_hoursNote",
  "hoursSlotGroup": "V-5r5q_hoursSlotGroup",
  "hoursSlotStack": "V-5r5q_hoursSlotStack",
  "infoBlock": "V-5r5q_infoBlock",
  "infoColumn": "V-5r5q_infoColumn",
  "layoutShell": "V-5r5q_layoutShell",
  "mapCard": "V-5r5q_mapCard",
  "mapColumn": "V-5r5q_mapColumn",
  "mapIframe": "V-5r5q_mapIframe",
});
